// extracted by mini-css-extract-plugin
export default {"relatedcourse-main":"RelatedCourses_relatedcourse-main__InFyi","heading":"RelatedCourses_heading__QHmYY","related-courses":"RelatedCourses_related-courses__ZwZOc"};